import api from '../../apiConfig/apiConfig'
import { Get, Post, Patch } from '../base/baseAjax'

export default {
  couponList(param) {
    return Post({
      url: api.coupon.couponList,
      bodyParam: param,
    })
  },
  getFunctionList() {
    return Get({
      url: api.coupon.functionList,
    })
  },
  getCustomerList() {
    return Get({
      url: api.coupon.customerList,
    })
  },
  addCoupon(param) {
    return Post({
      url: api.coupon.addCoupon,
      bodyParam: param,
    })
  },
  getCoupon(param) {
    return Get({
      url: api.coupon.getCoupon,
      PathParam: param,
    })
  },
  editCoupon(id, body) {
    return Patch({
      url: api.coupon.editCoupon,
      PathParam: id,
      bodyParam: body,
    })
  },
  setNullify(param) {
    return Patch({
      url: api.coupon.setNullify,
      PathParam: param,
    })
  },
}
